import {Observable, Subscription} from 'rxjs';
import {Destroyable} from '../../common';
import {ModelEventTarget} from '../../event';
import {IGraphic} from './graphic';

export abstract class DefaultGraphic extends Destroyable implements IGraphic {
  $element: JQuery;
  protected _modelEventTarget: ModelEventTarget;

  protected constructor() {
    super();
    this._modelEventTarget = new ModelEventTarget();
    this.onDestroy(() => {
      if (this._modelEventTarget) {
        this._modelEventTarget.destroy();
        this._modelEventTarget = null;
      }
    });
  }

  /**
   * 一般用于初始化  新建Graphic的时候调用
   * 如果有content的，则创建相应的content；负责配置面板的创建
   * @param option
   */
  abstract init(...params: Array<any>);

  abstract accept(model$: Observable<any>): Subscription;

  /**
   * 更新全局样式 目前只有Echart图表使用的到
   * @param {string} theme
   */
  updateTheme(theme: string) {
  }


  resize() {
  }

  activate() {
  }

  deactivate() {
  }
}

